import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LucideAngularModule,
  AlertCircleIcon,
  LogInIcon,
} from 'lucide-angular';
import { ModalService } from '../../../../core/services/modal.service';
import { LoginModalComponent } from '../login-modal/login-modal.component';

@Component({
  selector: 'app-login-required-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  template: `
    <div class="flex flex-col items-center gap-6 p-6">
      <div
        class="flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full"
      >
        <lucide-icon
          [img]="AlertCircleIcon"
          [size]="32"
          class="text-orange-600"
        ></lucide-icon>
      </div>

      <div class="text-center">
        <h3 class="text-xl font-semibold text-gray-900 mb-2">
          Connexion requise
        </h3>
        <p class="text-gray-600 text-sm leading-relaxed">
          Vous devez être connecté pour prendre un rendez-vous. Veuillez vous
          connecter pour continuer.
        </p>
      </div>

      <div class="flex gap-3 w-full">
        <button
          (click)="closeModal()"
          class="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
        >
          Annuler
        </button>
        <button
          (click)="openLoginModal()"
          class="flex-1 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors flex items-center justify-center gap-2"
        >
          <lucide-icon [img]="LogInIcon" [size]="16"></lucide-icon>
          Se connecter
        </button>
      </div>
    </div>
  `,
  styles: [],
})
export class LoginRequiredModalComponent {
  readonly AlertCircleIcon = AlertCircleIcon;
  readonly LogInIcon = LogInIcon;

  constructor(private modalService: ModalService) {}

  closeModal(): void {
    this.modalService.closeAll();
  }

  openLoginModal(): void {
    // Fermer le modal actuel
    this.modalService.closeAll();

    // Ouvrir le modal de connexion
    this.modalService.open({
      component: LoginModalComponent,
      width: '500px',
      title: 'Connexion',
      closable: true,
    });
  }
}
